import { AssessmentSectionModel } from "app/services/api/types/forms/models/AssessmentSectionModel";
import React from "react";
import { View, Text, FlatList } from "react-native";
import { AssessmentQuestion } from "../molecules/AssessmentQuestion";

interface Props {
  section: AssessmentSectionModel;
}
const AssessmentSection = React.forwardRef<unknown, Props>(
  ({ section }, ref) => {
    return (
      <View key={section.id}>
        <Text className="text-lg text-primary-400">{section.name}</Text>

        <FlatList
          data={section.questions}
          className="gap-6"
          keyExtractor={({ id }) => `${id}`}
          renderItem={({ item }) => <AssessmentQuestion question={item} />}
        ></FlatList>
      </View>
    );
  },
);

AssessmentSection.displayName = "AssessmentSection";
export { AssessmentSection };
